import { __assign, __rest } from "tslib";
import { jsx } from '@emotion/core';
import { components } from 'react-select';
import { layers } from '@atlaskit/theme/constants';
import { N40A } from '@atlaskit/theme/colors';
import SearchIcon from '@atlaskit/icon/glyph/editor/search';
export var MenuDialog = function (_a) {
    var maxWidth = _a.maxWidth, minWidth = _a.minWidth, props = __rest(_a, ["maxWidth", "minWidth"]);
    return (jsx("div", __assign({ css: {
            backgroundColor: 'white',
            borderRadius: 4,
            boxShadow: "0 0 0 1px " + N40A + ", 0 4px 11px " + N40A,
            maxWidth: maxWidth,
            minWidth: minWidth,
            zIndex: layers.modal(),
        } }, props)));
};
// ==============================
// Custom Components
// ==============================
var DropdownIndicator = function () { return (jsx("div", { css: { marginRight: 2, textAlign: 'center', width: 32 } },
    jsx(SearchIcon, { label: "open" }))); };
var Control = function (_a) {
    var innerRef = _a.innerRef, innerProps = _a.innerProps, props = __rest(_a, ["innerRef", "innerProps"]);
    return (jsx("div", { ref: innerRef, css: { padding: '8px 8px 4px' } },
        jsx(components.Control, __assign({}, props, { innerProps: innerProps }))));
};
export var DummyControl = function (props) { return (jsx("div", { css: {
        border: 0,
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: 1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: 1,
    } },
    jsx(components.Control, __assign({}, props)))); };
// NOTE `props` intentionally omitted from `Fragment`
// eslint-disable-next-line
var Menu = function (_a) {
    var children = _a.children, innerProps = _a.innerProps, props = __rest(_a, ["children", "innerProps"]);
    return (jsx("div", __assign({}, innerProps), children));
};
export var defaultComponents = { Control: Control, DropdownIndicator: DropdownIndicator, Menu: Menu };
//# sourceMappingURL=components.js.map